import styled, { css } from 'styled-components';
import { FAMILY_FONT_CONTROL, FAMILY_FONT_PRIMARY } from '../../const/text';
import { device } from '../../const/device';
import {
  PRIMARY_COLOR, SECONDARY_COLOR,
  SECONDARY_COLOR_1,
  SECONDARY_COLOR_2,
  SECONDARY_COLOR_5,
  SECONDARY_COLOR_6
} from '../../const/color';
import { ArrowIcon, SubmitSmallIcon } from '../../const/icons';
import { animated } from 'react-spring';

export const Selected = styled.div<{ active: boolean, selected: boolean, themeColor: string }>`
  position: relative;
  line-height: 160%;
  padding: 10px 16px;
  color: ${props => props.themeColor == 'black' ? props => props.selected ? SECONDARY_COLOR_5 : SECONDARY_COLOR_2 : props => props.selected ? SECONDARY_COLOR : SECONDARY_COLOR_2};
  background: ${props => props.themeColor == 'black' ? '#2e2e2e': '#fff'};
  
  &:before {
    content: '';
    position: absolute;
    right: 47px;
    top: 8px;
    height: 32px;
    width: 1px;
    background-color: ${props => props.themeColor == 'black' ? '#fff' : SECONDARY_COLOR_5};  
  }
  
  &:after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    
    background: url("data:image/svg+xml,${ArrowIcon(SECONDARY_COLOR_1)}") no-repeat center;
    background-size: 9px;
    transform: rotate(${props => props.active ? 90 : -90}deg);
    width: 47px;
    height: 100%;
  }
`;

export const TitleContainer = styled.div`

  padding-bottom:16px;
  width: 100%;
  background: white;
  z-index:2;
`;

export const TitleText = styled.div`
  display:flex;
  justify-content:space-between;
  align-items:center;
  font-size:14px;
  line-height:18px;
  color: #000;
`;

export const TitleSearch = styled.div`
  margin-top: 10px;
`;

export const FooterContainer = styled.div<{disable?:string}>`
  position:fixed;
  bottom:100px;
  z-index:2;
  width: calc(100% - 48px);
  font-size:12px;
  text-align:center;
  padding:24px;
  border-top: 1px solid ${SECONDARY_COLOR_6};
  background: #000000;
  color: #ffffff;

  opacity: ${props => props.disable === "true" ? "0.5" : "1"};
  pointer-events: ${props => props.disable === "true" ? "none" : "auto"};
`;

export const ItemsContainer = styled.div`
  overflow-y:auto;
`;

export const FontsContainer = styled(ItemsContainer)`
  height:auto;
`;

export const MembersContainer = styled(ItemsContainer)`
  height:auto;
  margin-bottom: 70px;
`;

export const Item = styled.div<{ selected: boolean }>`
  height: 40px;
  font-size: 16px;
  line-height: 160%;
  padding: 11px 8px 3px 24px;
  color: ${SECONDARY_COLOR_2};
  
  ${props => props.selected ? css`
    background-color: ${SECONDARY_COLOR_6};
  ` : ''}
  &:hover {
    color: ${PRIMARY_COLOR}
  }
`;

export const MobileItem = styled.div<{ selected: boolean }>`
  font-size: 14px;
  line-height: 160%;
  padding: 12px;
  color: ${SECONDARY_COLOR_2};
  font-family:${FAMILY_FONT_CONTROL};
  border-bottom: 1px solid ${SECONDARY_COLOR_6};
  font-weight:400;
  position:relative;

  &:last-child{
    border-bottom:none;
  }
  
  ${props => props.selected ? css`
  font-weight:700;
  ` : ''
  }

  &:hover {
    color: ${PRIMARY_COLOR}
  }
`;

export const MobileFontItem = styled(MobileItem)`
  padding: 12px 0 12px 30px;

  ${props => props.selected ? css`
  &:before{
    content:'';
    width:15px;
    height:15px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin-top: 15px;
    margin-left: 5px;
    position: absolute;
    background: url("data:image/svg+xml,${SubmitSmallIcon(PRIMARY_COLOR)}");
    background-size:cover;
  }
  ` : ''
  }
`;

export const MobileMemberItemWrap = styled.div`
  display:flex;
  align-items:center;
`;

export const MobileMemberItemContent = styled.div`
  display:flex;
  align-items:center;
  width:100%;
`;

export const ContentContainer = styled.div<{ themeColor: string }>`
  padding: 7px 0 8px;
  max-height: calc(100vh - 640px);
  height:auto;
  min-height:100px;
  overflow-y: auto;
  background: ${props => props.themeColor == 'black'?'#2e2e2e':'#fff'};
`;

export const MobileContainer = styled(animated.div)`
  font-family:${FAMILY_FONT_PRIMARY};
  font-weight:normal;
  background: white;
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 24px 24px 0 24px;
  z-index: 2;
  bottom: -100px;
  padding-bottom:100px;
`;
export const MobileContentContainer = styled.div`
  overflow-y: scroll;
  touch-action: none;
  height:100%;
  position:relative;
  display: flex;
  flex-direction: column;
 
`;

export const MobilePlaceholder = styled(animated.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: black;
  opacity: 0.5;
`;

export const Container = styled.div<{ active?: boolean, themeColor: string }>`
  border: ${props => props.themeColor == 'black'?'0px': props => props.active ? '1px solid #A0A3A8' : '1px solid #E8E8E8'};
  font-family: ${FAMILY_FONT_CONTROL};
  border-radius: 2px;
  position: absolute;
  cursor: pointer;
  //padding: 11px 16px;
  font-size: 16px;
  background: ${props => props.themeColor == 'black'?'#2e2e2e':'#fff'};
  color: ${SECONDARY_COLOR_2};
  user-select: none;
  //padding: 8px;
  background:white;
  margin-bottom: 20px;
  z-index: 999;
  width: 100%;

  @media (${device.mobileL}) {
    margin-bottom: 0px;
    z-index: 1;
  }

  @media (${device.tablet}) {
    z-index: 1;
  }

  
  &:hover {
    border: ${props => props.themeColor == 'black'?'0px':'1px solid #A0A3A8'};
  }
`;